// Providers
import { useProfilesStore } from '@/utils/zustand/providers/profiles-provider';

// Hooks
import useActiveGroup from '@/utils/hooks/user/useActiveGroup';

// Components
import { GroupItem } from '@/components/composite/SelectedProfiles/GroupProfiles/GroupItem';
import { ProfilesList } from '@/components/composite/SelectedProfiles/ProfilesList';

// Types
import type { SelectedProfilesProps } from '@/components/composite/SelectedProfiles';

export function GroupProfiles({ itemsSize }: Required<SelectedProfilesProps>) {
    const { activeGroup } = useActiveGroup();
    const { activeSocialProfileId } = useProfilesStore((state) => state);
    const socialProfiles = activeGroup.social_profiles.filter((profiles) => profiles.active);

    return (
        <div className="flex items-center gap-4">
            <GroupItem
                itemsSize={itemsSize}
                group={activeGroup}
                isActive={!activeSocialProfileId}
            />
            <span className="h-5 w-0.5 bg-icoGray-300 dark:bg-icoDarkMode-beton" />
            <ProfilesList itemsSize={itemsSize} profiles={socialProfiles} />
        </div>
    );
}
